<template>
    <legacy-group-report-template  v-model:for-group="forGroup"
                            v-model:interval="$data._interval"
                            v-model:reload-data="$data._reloadTable"
                            report-name="detailed-alarm-report"
                            v-model:running-errors="$data._errorSending"
                            v-model:ran-report="$data._reportSuccessfullySent"
                            v-model:running-report="$data._runningReport"
                            v-model:current-report-template-id="currentReportTemplateId"
                            v-model:settings="$data._settings"
                            v-model:display-section="displaySection"
                            v-model:users="users"
                            :can-edit="permissions.can('manage_detailed_alarm_report')"
                            :default-settings="defaultSettings"
                            @useStandardReporting="setUseStandardReporting"
    >
        <template   #create-settings>
            <legacy-detailed-alarm-report-settings
                v-model:interval="$data._interval"
                v-model:receive-weekday="$data._settings['receiveWeekday']"
                v-model:settings="$data._settings"
                :is-savable="true"
            ></legacy-detailed-alarm-report-settings>
        </template>

        <template   #edit-settings>
            <legacy-detailed-alarm-report-settings
                v-model:interval="$data._interval"
                v-model:receive-weekday="$data._settings['receiveWeekday']"
                v-model:settings="$data._settings"
                :is-savable="displaySection === 'show-template' || useStandardReporting"
            ></legacy-detailed-alarm-report-settings>
        </template>

        <template   #run-options="props">
            <legacy-meter-interval-selection   :meters="metersByGroup[props.groupId]"
                                        v-model:selected-meters="$data._selectedMeters"
                                        v-model:interval="$data._interval"
                                        v-model:end-of-interval="endOfInterval"
                                        :max-date="maxDate"
                                        :min-date="minDate"
                                        :timezone="timezone"
                                        @run-report="runReport(currentReportTemplateId)"
            ></legacy-meter-interval-selection>
        </template>
    </legacy-group-report-template>
</template>

<script>
import axios from "axios"
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import ReportHomeModal from "@/components/GroupReports/Legacy/LegacyReportHomeModal.vue";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary";
import BaseReport from "@/components/Reports/BaseReport";
import MeterIntervalSelection from "@/components/GroupReports/Legacy/LegacyMeterIntervalSelection.vue";
import DetailedAlarmReportSettings from "@/components/GroupReports/Legacy/LegacyDetailedAlarmReportSettings.vue";
import AjaxTable from "@/components/elements/AjaxTable";
import Select2 from "@/components/elements/select2";
import SlideOverPanel from "@/components/elements/SlideOverPanel";
import ButtonRedSecondary from "@/components/elements/buttons/ButtonRedSecondary";
import ButtonGreenPrimary from "@/components/elements/buttons/ButtonGreenPrimary";
import GroupReportTemplate from "@/components/GroupReports/Legacy/LegacyGroupReportTemplate.vue";
import AlarmResolutionReportSettings from "@/components/GroupReports/Legacy/LegacyAlarmResolutionReportSettings.vue";

export default {
    name: "GroupDetailedAlarmReport",
    mixins: [SonicuCoreMixin, ajaxTableMixin],
    components: {
        AlarmResolutionReportSettings,
        GroupReportTemplate,
        ButtonGreenPrimary,
        ButtonRedSecondary,
        SlideOverPanel,
        AjaxTable,
        DetailedAlarmReportSettings, MeterIntervalSelection, BaseReport, ReportHomeModal, ButtonBlueSecondary, Select2,
        Menu, MenuButton, MenuItem, MenuItems,
    },
    props: {
        receiveWeekday: {
            type: Number,
            default: 1,
        },
        interval: {
            type: String,
            default: 'monthly',
        },
        metersByGroup: {
            type: Object,
            default() {
                return {}
            },
        },
        users: {
            type: Object,
            default() {
                return {}
            }
        },
        minDate: {
            type: Date,
        },
        maxDate: {
            type: Date,
        },
        defaultSettings: {
            type: Object,
            default() {
                return {}
            }
        },
        timezone: {
            type: String,
            default: 'America/New_York'
        },
    },
    data() {
        return {
            displaySection: null,

            // Manual Run Stuff
            _interval: this.interval,
            endOfInterval: new Date(),
            _selectedMeters: [],
            _templateName: '',
            _groupId: null,

            _data: [],

            _reloadTable: false,
            _settings: this.defaultSettings,
            _runningReport: false,
            _reportSuccessfullySent: false,
            _errorSending: [],

            currentReportTemplateId: null,
            forGroup: false,

            useStandardReporting: false,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        runReport(reportTemplateId = null) {
            console.log(`Running report on DAR file w/ reportTemplateIndex: ${reportTemplateId}`)
            let params = {}
            if (reportTemplateId !== null) {
                params['reportTemplateId'] = reportTemplateId
                params['forGroup'] = this.forGroup
            }
            else {
                params['interval'] = this.$data._interval
            }

            params['end'] = this.$data.endOfInterval
            params['meters'] = this.$data._selectedMeters

            // return
            this.$data._runningReport = true
            axios.post(this.company.buildCompanyRoute('group-reports/detailed-alarm-report'), params)
                .then(response => {
                    let data = response.data
                    console.log(`Report Queued successfully, data is`)
                    console.log(data)
                    // Clear the error logs, since the report is done.
                    this.$data._reportSuccessfullySent = true
                    this.$data._errorSending = []
                })
                .catch(response => {
                    let data = response.data
                    console.log(`Report Queued Failed, data is`)
                    console.log(data)
                    // Store the logs from errors to show.
                    this.$data._errorSending = data
                })
                .finally(() => {
                    console.log(`Report finalizing`)
                    // Finish the sending of the report.
                    this.$data._runningReport = false
                })
        },
        resetTemplateRun() {
            this.currentReportTemplateIndex = null
            this.forGroup = false
        },
        setUseStandardReporting(event) {
            this.useStandardReporting = event
        }
    },
    computed: {},
    watch: {
        _settings(val, old) {
            if (val !== old) {
                this.$data._settings = val
            }
        },
        defaultSettings(val, old) {
            if (val !== old) {
                this.$data._settings = val
            }
        },
    },
}
</script>

<style scoped>

</style>